<template>
  <v-container>
    <v-title>
      <slot></slot>
    </v-title>
    <v-data-table
      :disabled="disabled"
      v-model="selected"
      :headers="headers"
      :items="serviceRequirements"
      class="elevation-1"
      item-key="csn"
      select-all
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-if="selectable">
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll"
            ></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text">
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <tr :active="props.selected" @click="selectSQ(props)">
          <td v-if="selectable">
            <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
          </td>
          <td v-for="(prop,propIndex) in headers" :key="propIndex" :class="'ma-0'">
            <div v-if="isDateColumn(prop.value)">{{props.item[prop.value] | formatDate}}</div>
            <div v-else :class="'text-xs-' + prop.align">{{props.item[prop.value]}}</div>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">This customer has no services connected</v-alert>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "UtilitySQ",
  props: {
    serviceRequirements: Array,
    selectable: Boolean,
    disabled: Boolean,
    selectedSQ: Array
  },
  data() {
    return {
      selected: [],
      headers: [
        {
          text: "CSN",
          align: "left",
          sortable: true,
          value: "csn"
        },
        {
          text: "Description",
          align: "left",
          sortable: true,
          value: "servicePlanDescription"
        },
        // {
        //   text: "Customer Number",
        //   align: "left",
        //   sortable: true,
        //   isDescending: true,
        //   value: "customerNumber"
        // },
        {
          text: "Date Added",
          align: "left",
          sortable: true,
          value: "serviceDateAdded"
        },
        {
          text: "Usage Type",
          align: "left",
          sortable: true,
          value: "usageType"
        }
      ]
    };
  },
  mounted() {
    let vm = this;
    vm.$nextTick(() => {
      if (vm.selectedSQ) vm.selected = vm.selectedSQ;
      // else if (vm.serviceRequirements) {
      //   vm.selected = vm.serviceRequirements;
      // }
    });
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.serviceRequirements.slice();
      this.$emit("getSelected", this.selected);
    },

    selectSQ(props) {
      props.selected = !props.selected;
      this.$emit("getSelected", this.selected);
    },
    isDateColumn(name) {
      if (
        name.toLowerCase().includes("date") ||
        name.toLowerCase().includes("start") ||
        name.toLowerCase().includes("end")
      )
        return true;
      return false;
    }
  }
};
</script>

<style>
</style>
